import React from 'react';
import { Typography } from '@creditas-ui/typography';
import { ButtonSecondary } from '@creditas-ui/button';
import { useTimer } from './useTimer';
import i18n from '../../../../i18n';

const TOTAL_TIME_IN_SECONDS = 300;

export type ResendAccessCodeProps = {
  onActionLinkClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
};

const ResendAccessCode = ({ onActionLinkClick }: ResendAccessCodeProps): JSX.Element => {
  const { isActive, getMinutes, getSeconds, start } = useTimer(TOTAL_TIME_IN_SECONDS);

  return isActive ? (
    <Typography color="neutral.60" variant="bodySmRegular">
      {i18n.t('flows:shared.access_code_step.timer.valid_access_code', {
        minute: getMinutes(),
        second: getSeconds(),
      })}
    </Typography>
  ) : (
    <ButtonSecondary
      onClick={(event): void => {
        start();
        onActionLinkClick(event);
      }}
    >
      {i18n.t('flows:shared.access_code_step.timer.resend')}
    </ButtonSecondary>
  );
};

export { ResendAccessCode, TOTAL_TIME_IN_SECONDS };
